import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { InternalAuthenticationService } from './internal-auth.service';
import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

export class InternalAuthHttpInterceptor implements HttpInterceptor {
  internalAuth = inject(InternalAuthenticationService);
  isAuthenticated = toSignal(this.internalAuth.isAuthenticated$);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!this.isAuthenticated()) return next.handle(req);

    return this.internalAuth.getAccessTokenSilently().pipe(
      take(1),
      switchMap((x) => {
        const modified = req.clone({
          headers: req.headers.set('authorization', `Bearer ${x}`),
        });

        return next.handle(modified);
      })
    );
  }
}
